import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const imgUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http") || src.startsWith("data:")) return src;
  return `${BACKEND}${src}`;
};

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  } catch { return ""; }
}

export default function Blog() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  return (
    <div className="bg-ink text-white min-h-screen pt-32 pb-24" data-testid="blog-page">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-mono text-[11px] uppercase tracking-[0.4em] text-adrenaline">The Lone Star Speed Journal</div>
        <h1 className="text-display text-6xl md:text-8xl uppercase leading-none mt-3">Stories From The Strip</h1>
        <p className="text-zinc-400 mt-5 max-w-2xl">Build guides, wheel tech, fitment deep-dives, and Texas car culture. Straight from the Lone Star Speed garage.</p>
        <div className="section-divider mt-12 mb-12" />

        {posts === null && (
          <div className="text-mono text-zinc-500 text-sm uppercase tracking-widest">Loading…</div>
        )}
        {posts && posts.length === 0 && (
          <div className="text-center py-20" data-testid="blog-empty">
            <div className="text-mono text-zinc-500 text-sm uppercase tracking-widest">First articles drop soon.</div>
            <Link to="/" className="text-mono text-xs uppercase tracking-[0.3em] mt-6 inline-block border border-white/20 px-6 py-3 hover:border-white transition-colors">← Back to Home</Link>
          </div>
        )}
        {posts && posts.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-1">
            {posts.map((p) => (
              <Link
                key={p.id}
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group bg-carbon border border-white/5 hover:border-adrenaline/60 transition-colors block"
              >
                {p.hero_image && (
                  <div className="aspect-[16/9] overflow-hidden bg-black">
                    <img src={imgUrl(p.hero_image)} alt={p.hero_image_alt || p.title} className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-700" loading="lazy" />
                  </div>
                )}
                <div className="p-6">
                  <div className="flex flex-wrap gap-2 mb-3">
                    {(p.tags || []).slice(0, 3).map((t) => (
                      <span key={t} className="text-mono text-[10px] uppercase tracking-[0.3em] text-adrenaline">{t}</span>
                    ))}
                  </div>
                  <h2 className="text-display text-2xl md:text-3xl uppercase leading-tight group-hover:text-adrenaline transition-colors">{p.title}</h2>
                  {p.excerpt && <p className="text-zinc-400 text-sm mt-3 leading-relaxed line-clamp-3">{p.excerpt}</p>}
                  <div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mt-4">{formatDate(p.published_at)} · {p.author}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
